import { createApp } from "vue";
import vClickOutside from "click-outside-vue3";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { far } from "@fortawesome/free-regular-svg-icons";
import { fab } from "@fortawesome/free-brands-svg-icons";
import Emitter from "tiny-emitter";
import "@quasar/extras/fontawesome-v6/fontawesome-v6.css";

import App from "./App.vue";
import Quasar from 'quasar/src/vue-plugin.js';;
import quasarUserOptions from "./quasar-user-options";
import router from "./router";
import store from "./store";
import { MsalPlugin } from "./plugins/msal-plugin";
import { AppConfig } from "./app.config";

const options = {
  clientId: AppConfig.msalClientID,
  authority: AppConfig.msalLoginAuthority,
};

// Add all Libs for Font-awsome v6
library.add(fas, far, fab);

// Using: vue-router, quasar, vueX, FontAwesomeIcon
let app = createApp(App);
app.config.globalProperties.$account = null;
app.config.globalProperties.$msal = MsalPlugin;
app.config.globalProperties.$emitter = new Emitter();
app
  .use(vClickOutside)
  .use(router)
  .use(store)
  .use(new MsalPlugin(), options)
  .use(Quasar, quasarUserOptions)
  .component("font-awesome-icon", FontAwesomeIcon)
  .mount("#app");
